module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": "",
      "fluid": "",
      "id": "home"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm3": "",
      "id": "home-notifications"
    }
  }, [_c('div', {
    staticClass: "text-xs-center pt-2 pb-1 grey lighten-4"
  }, [_c('h2', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v(_vm._s(_vm.now))]), _vm._v(" "), _c('p', {
    staticClass: "grey--text ma-0"
  }, [_vm._v(_vm._s(_vm.user.organizationName))])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("\n              " + _vm._s(_vm.$t("home.notification")) + " (" + _vm._s(_vm.notifications.length) + ")\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, _vm._l((_vm.notifications), function(notfctn) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: 'watersystem_list/' + notfctn.id
        }
      }
    }, [_c('v-alert', {
      staticClass: "ma-2 pa-1 lighten-5",
      class: notfctn.type == 'error' ? 'red' : 'orange',
      attrs: {
        "outline": "",
        "color": notfctn.type,
        "icon": notfctn.type,
        "value": true
      }
    }, [_c('span', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(notfctn.title))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "body-2"
    }, [_vm._v("[ " + _vm._s(notfctn.service) + " ]")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(notfctn.message))])])], 1)], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "  grey lighten-5 pt-2 pr-4 pl-4",
    attrs: {
      "xs12": "",
      "sm9": "",
      "id": "home-main"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.information))])]), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-card', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "infomation-text"
  }, [_vm._v(_vm._s(this.mailDate) + " - " + _vm._s(_vm.$t("home.mail-notification-top")))]), _vm._v(" "), _c('div', {
    staticClass: "infomation-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.mail-notification-under', ['./settings/notifications_mail']))
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "mt-4"
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("home.quick-link")))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    },
    on: {
      "click": function($event) {
        _vm.quickLink('customer')
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "size": "40px",
      "tile": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/stats-pin.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('span', {
    staticClass: "blue--text caption"
  }, [_vm._v(_vm._s(_vm.$t("global-menu.watersystem")))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("watersystem.customer")) + " (" + _vm._s(_vm.locationCount) + ")")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    },
    on: {
      "click": function($event) {
        _vm.quickLink('device')
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "size": "40px",
      "tile": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/stats-iotizr.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('span', {
    staticClass: "blue--text caption"
  }, [_vm._v(_vm._s(_vm.$t("global-menu.watersystem")))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("watersystem.device")) + " (" + _vm._s(_vm.filtrationSystemCount) + ")")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "mt-4"
  }, [_c('v-expansion-panel-content', {
    staticClass: "grey lighten-2",
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("home.calendar")))])]), _vm._v(" "), _c('v-card', {
    staticClass: "white pa-2"
  }, [_c('full-calendar', {
    attrs: {
      "events": _vm.calendarEvents,
      "config": _vm.calendarConfig
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-6f64953c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1938
// module chunks = 0